import React from 'react'

const NotificacionesPage = () => {
  return (
    <div>NotificacionesPage</div>
  )
}

export default NotificacionesPage